import { render, staticRenderFns } from "./IdentificationScreen.vue?vue&type=template&id=1898dd7b&"
import script from "./IdentificationScreen.vue?vue&type=script&lang=js&"
export * from "./IdentificationScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports